import { GrtAiMarkdown } from '@/components/Markdown/GrtAiMarkdown';
import { data } from './mock';
import { code } from './code';
import { table } from './table';
import { img } from './img';
const content = `
\`\`\`js
import React from "react";

function App() {
  return <h1>Hello, React!</h1>;
}
\`\`\`
`;
const Test = () => {
    return (
        <div style={{ width: '100vw', height: '100vh' }}>
            {/* <GrtAiMarkdown content={img} /> */}
            <iframe style={{ width: '100%', height: '100%' }} src="https://test-agent.grtcloud.net/ai_simulation.html" frameBorder="0"></iframe>
        </div>
    );
};

export default Test;
